/**
 * Footer.jsx
 * Site-wide footer for QuitPact.
 *
 * Sections:
 *   - Brand + tagline
 *   - Quick links
 *   - Support resources (Australian helplines)
 *   - Disclaimer + copyright
 *
 * Team: TA37 - The Coders' Assembly
 */

import React from 'react';
import { NavLink } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer__inner">

        {/* -- Brand -- */}
        <div className="footer__brand">
          <img src="/logo.png" alt="QuitPact logo" className="footer__logo" />
          <p className="footer__tagline">QuitPact to create an Impact</p>
          <p className="footer__description">
            A free, real-time relapse risk tool built for Australians who want
            to quit smoking for good.
          </p>
        </div>

        {/* -- Quick links -- */}
        <div className="footer__col">
          <h4 className="footer__col-heading">Quick Links</h4>
          <ul className="footer__links">
            <li><NavLink to="/" className="footer__link" end>Home</NavLink></li>
            <li><NavLink to="/check-in" className="footer__link">Check-In</NavLink></li>
            <li><NavLink to="/cost-calculator" className="footer__link">Cost Calculator</NavLink></li>
            <li><NavLink to="/health-awareness" className="footer__link">Health Awareness</NavLink></li>
            <li><NavLink to="/quit-benefits" className="footer__link">Quit Benefits</NavLink></li>
          </ul>
        </div>

        {/* -- Support resources -- */}
        <div className="footer__col">
          <h4 className="footer__col-heading">Support Resources</h4>
          <ul className="footer__links">
            <li>
              
                <a href="https://www.quitline.com.au"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Quitline — 13 7848
              </a>
            </li>
            <li>
              
                <a href="https://www.icanquit.com.au"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                iCanQuit
              </a>
            </li>
            <li>
              
                <a href="https://www.beyondblue.org.au"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Beyond Blue
              </a>
            </li>
            <li>
              
                <a href="https://www.health.gov.au/topics/smoking-and-tobacco"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Australian Dept. of Health
              </a>
            </li>
          </ul>
        </div>

      </div>

      {/* -- Bottom bar -- */}
      <div className="footer__bottom">
        <p className="footer__disclaimer">
          QuitPact is for informational purposes only and does not constitute
          medical advice. Always consult a healthcare professional.
        </p>
        <p className="footer__copyright">
          © 2026 QuitPact · The Coders' Assembly
        </p>
      </div>

    </footer>
  );
};

export default Footer;